





















import Component from 'vue-class-component'
import Vue from 'vue'
import {State} from 'vuex-class'
import ApiVersion from '@/modules/app-router/model/ApiVersion'
import {Prop} from 'vue-property-decorator';

/**
 * Selector de versión de API
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ApiVersionSelect extends Vue {
    /**
     * Lista de versiones declaradas por la API actualmente seleccionada
     */
    @State(state => state.appRouter.currentApi.versions)
    public versions: ApiVersion[]

    /**
     * Versión de la API actualmente seleccionada
     */
    @Prop(({type: ApiVersion, default: null}))
    public value: ApiVersion

    /**
     * Reglas de validación para el campo
     */
    @Prop({type: Array, default: () => ([])})
    public rules: Array<(value: any) => string | false>
}
